import { Alert as MuiAlert, AlertProps } from '@mui/material'

export const Alert = (props: AlertProps) => <MuiAlert {...props} />